import { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faBuilding,
  faCheckCircle,
  faTimesCircle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import { database } from "../components/firebase";
import { ref, set, push } from "firebase/database";
import "./Contact.css";

const APPS_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxZWOZWH33TMlCzpsnKrgRvrgrfw7RX_QZfJy4BtAv6vWJC1UUGvK_JsrAn7r_oSwVItw/exec";

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  // popup: null | { type: "success" | "error", message: string }
  const [popup, setPopup] = useState(null);

  const closePopup = () => setPopup(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "");
      setFormData({ ...formData, phone: numericValue.slice(0, 10) });
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.phone.length !== 10) {
      setPopup({ type: "error", message: "Phone number must be exactly 10 digits." });
      return;
    }

    setLoading(true);

    try {
      const today = new Date().toISOString().split("T")[0];

      // Save to Firebase
      const messagesRef = ref(database, `contacts/${today}`);
      const newMessageRef = push(messagesRef);
      await set(newMessageRef, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        timestamp: new Date().toISOString(),
      });

      // Save to Google Sheet via Apps Script (no-cors — fire and forget)
      fetch(APPS_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }),
      });

      setFormData({ name: "", email: "", phone: "", message: "" });
      setPopup({ type: "success", message: "Your message has been sent successfully! We'll get back to you soon." });
    } catch (error) {
      console.error("Error submitting message:", error);
      setPopup({ type: "error", message: "Failed to send message. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">

      {/* ── Popup Modal ── */}
      {popup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className={`popup-box popup-${popup.type}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="popup-close" onClick={closePopup} aria-label="Close">
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="popup-icon">
              <FontAwesomeIcon
                icon={popup.type === "success" ? faCheckCircle : faTimesCircle}
              />
            </div>
            <h4>{popup.type === "success" ? "Message Sent!" : "Something went wrong"}</h4>
            <p>{popup.message}</p>
            <button className="popup-btn" onClick={closePopup}>
              {popup.type === "success" ? "Great, Thanks!" : "Try Again"}
            </button>
          </div>
        </div>
      )}

      {/* Hero Banner */}
      <div className="contact-hero">
        <div className="contact-hero-overlay">
          <h1 data-aos="fade-down">Contact Us</h1>
          <p data-aos="fade-up" data-aos-delay="200">
            Reach out for packaging material inquiries, bulk orders, or any assistance.
          </p>
        </div>
      </div>

      <Container className="contact-container">

        {/* Info Cards */}
        <Row className="contact-cards-row g-4 mt-2">
          <Col xs={12} md={6} lg={3} data-aos="fade-up">
            <div className="contact-card">
              <div className="contact-card-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <h5>Work Address</h5>
              <p onClick={() => window.open("https://www.google.com/maps?q=Satav+Industrial+Estate,+Chakan,+Pune", "_blank")}>
                Gat No. 374, Satav Industrial Estate,<br />
                Chakan Talegaon Rd, Kharabwadi,<br />
                Chakan, Pune – 410501
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3} data-aos="fade-up" data-aos-delay="100">
            <div className="contact-card">
              <div className="contact-card-icon">
                <FontAwesomeIcon icon={faBuilding} />
              </div>
              <h5>Office Address</h5>
              <p onClick={() => window.open("https://www.google.com/maps?q=Stealla+Tower,+Moshi,+Pune", "_blank")}>
                Stealla Tower,<br />
                Moshi Alandi Rd, Moshi,<br />
                Pune – 412105
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3} data-aos="fade-up" data-aos-delay="200">
            <div className="contact-card">
              <div className="contact-card-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <h5>Call Us</h5>
              <p onClick={() => (window.location.href = "tel:+919834430943")}>
                +91 9834430943<br />
                <span className="contact-name">Mr. Vikrant Vele</span>
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3} data-aos="fade-up" data-aos-delay="300">
            <div className="contact-card">
              <div className="contact-card-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <h5>Email Us</h5>
              <p onClick={() => (window.location.href = "mailto:anvikaind.1supplier@gmail.com")}>
                anvikaind.1supplier<br />@gmail.com
              </p>
            </div>
          </Col>
        </Row>

        {/* Form + Map */}
        <Row className="mt-5 g-4 align-items-start">
          <Col xs={12} lg={6} data-aos="fade-right">
            <div className="contact-form-box">
              <h2>Send Us a Message</h2>
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col xs={12} sm={6}>
                    <Form.Group controlId="formName">
                      <Form.Label>Your Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Group controlId="formEmail">
                      <Form.Label>Your Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group controlId="formPhone">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter 10-digit phone number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        maxLength={10}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group controlId="formMessage">
                      <Form.Label>Your Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Type your message here..."
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} className="text-center">
                    <Button
                      type="submit"
                      className="contact-submit-btn"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>

          <Col xs={12} lg={6} data-aos="fade-left">
            <div className="map-box">
              <h2>Find Us on the Map</h2>
              <iframe
                title="Google Maps Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.5!2d73.86!3d18.76!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9!2sChakan%2C+Pune!5e0!3m2!1sen!2sin!4v1"
                width="100%"
                height="380"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default Contact;
